import useGTM from './useGTM';
import useMixpanel from './useMixpanel';

const useTracking = () => {
  const mixpanel = useMixpanel();
  const gtm = useGTM();

  return {
    mixpanel,
    gtm
  };
};
export default useTracking;
